import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class ShopResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("ShopResourcePackage");
    }
    public get assets_views_shop_shop_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/shop/shop_1x.atlas.json");
    }
    public get assets_views_shop_glass_long_png(): Texture {
        return this.assets_views_shop_shop_1x_atlas_json.textures["glass_long.png"];
    }
    public get assets_views_shop_snape_yelow_long_png(): Texture {
        return this.assets_views_shop_shop_1x_atlas_json.textures["snape_yelow_long.png"];
    }
    public get assets_views_shop_glass_png(): Texture {
        return this.assets_views_shop_shop_1x_atlas_json.textures["glass.png"];
    }
    public get assets_views_shop_shape_green_png(): Texture {
        return this.assets_views_shop_shop_1x_atlas_json.textures["shape_green.png"];
    }
    public get assets_views_shop_shape_orange_png(): Texture {
        return this.assets_views_shop_shop_1x_atlas_json.textures["shape_orange.png"];
    }
    public get assets_views_shop_shape_violet_png(): Texture {
        return this.assets_views_shop_shop_1x_atlas_json.textures["shape_violet.png"];
    }
    public get assets_views_shop_dice_icon_png(): Texture {
        return this.assets_views_shop_shop_1x_atlas_json.textures["dice_icon.png"];
    }
    public get assets_views_shop_mon_icon_png(): Texture {
        return this.assets_views_shop_shop_1x_atlas_json.textures["mon_icon.png"];
    }
    public get assets_views_shop_shop_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/shop/shop_1x.atlas.png");
    }
}

